export const MODAL_ROOT_ID = 'modal-root';
export const HINT_ROOT_ID = 'hint-root';
export const TOAST_ROOT_ID = 'toast-root';

const cache = new Map<string, HTMLElement>();
const overrides = new Map<string, HTMLElement>();
const listeners = new Set<() => void>();

const isAttached = (node: HTMLElement): boolean => !!node && document.contains(node);

const notify = () => {
    listeners.forEach((listener) => listener());
};

export const subscribePortalRoot = (listener: () => void): (() => void) => {
    listeners.add(listener);

    return () => {
        listeners.delete(listener);
    };
};

export const getPortalRoot = (id: string): HTMLElement => {
    const override = overrides.get(id);

    if (isAttached(override)) {
        return override;
    }

    const existing = document.getElementById(id) as HTMLElement;

    if (existing) {
        cache.set(id, existing);

        return existing;
    }

    const cached = cache.get(id);

    if (isAttached(cached)) {
        return cached;
    }

    const created = document.createElement('div');
    created.id = id;
    document.body.appendChild(created);
    cache.set(id, created);

    return created;
};

export const setPortalRootOverride = (id: string, element: HTMLElement) => {
    if (overrides.get(id) === element) {
        return;
    }

    overrides.set(id, element);
    notify();
};

export const clearPortalRootOverride = (id: string, element?: HTMLElement) => {
    if (!overrides.has(id)) {
        return;
    }

    if (element && overrides.get(id) !== element) {
        return;
    }

    overrides.delete(id);
    notify();
};
